import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id E62A084A-2136-4FD3-8803-A72DE26D60CB
 * name bottle-soda-classic
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-soda-classic.svg
 * tags
 * - Food / Drink 
 */
export const BottleSodaClassicIcon = createSvgIcon(<><path d="M15 13.77A3 3 0 0 0 15 18.23V20A2 2 0 0 1 13 22H11A2 2 0 0 1 9 20V18.23A3 3 0 0 0 9 13.77V9A12.28 12.28 0 0 0 10.91 4H10V2H14V4H13.09A12.28 12.28 0 0 0 15 9Z" /></>, 'BottleSodaClassicIcon');
export default BottleSodaClassicIcon